import { createRouter, createWebHistory } from 'vue-router'
// v3
import EstimateV3 from './views/v3/Estimate.vue'
import EstimateDetailV3 from './views/v3/EstimateDetailAfter.vue'
import CarV3 from './views/v3/Car.vue'
import InspectionSettlementV3 from './views/v3/InspectionSettlement.vue'
import InspectionSettlementCompleteV3 from './views/v3/InspectionSettlementComplete.vue'
import CarCareTopV3 from './views/v3/CarCareTop.vue'
import PreferredDateV3 from './views/v3/PreferredDate.vue'
import PaymentV3 from './views/v3/Payment.vue'
import InspectionThanksV3 from './views/v3/InspectionThanks.vue'
import InspectionDetailV3 from './views/v3/InspectionDetail.vue'
import LeaseTopV3 from './views/v3/LeaseTop.vue'
import InspectionTopV3 from './views/v3/InspectionTop.vue'
import CardSpecSelectV3 from './views/v3/CardSpecSelect.vue'
import CardSpecOpusV3 from './views/v3/CardSpecOpus.vue'
import CardSpecHouseV3 from './views/v3/CardSpecHouse.vue'
import OptionCarQRV3 from './views/v3/OptionCarQR.vue'
import RedirectCarV3 from './views/v3/RedirectCar.vue'
import RedirectPreferredDateV3 from './views/v3/RedirectPreferredDate.vue'
import AccountDeleteConfirmV3 from './views/v3/AccountDeleteConfirm.vue'
import AccountDeleteCompleteV3 from './views/v3/AccountDeleteComplete.vue'
import MaintenancePackTopV3 from './views/v3/MaintenancePack/Top.vue'
import CarInspectionConfirmV3 from './views/v3/MaintenancePack/CarInspectionConfirm.vue'
import MaintenancePackApplyV3 from './views/v3/MaintenancePack/Apply.vue'
import MaintenancePackTermsOfServiceV3 from './views/v3/MaintenancePack/TermsOfService.vue'
import MaintenancePackApplyCompleteV3 from './views/v3/MaintenancePack/ApplyComplete.vue'
import AppTopV3 from './views/v3/AppTop.vue'
import MaintenanceReservationV3 from './views/v3/MaintenanceReservationV3.vue'

const routes = [
  // v3
  {
    // 見積もり掲示画面・詳細画面（予約前）
    path: '/v3/estimate',
    name: 'EstimateV3',
    component: EstimateV3
  },
  {
    // 見積り詳細画面（予約後）
    path: '/v3/estimatedetail',
    name: 'EstimateDetailV3',
    component: EstimateDetailV3
  },
  {
    // 車検情報入力画面
    path: '/v3/car',
    name: 'CarV3',
    component: CarV3
  },
  {
    // クレジット選択画面
    path: '/v3/inspectionSettlement',
    name: 'InspectionSettlementV3',
    component: InspectionSettlementV3
  },
  {
    // 決済完了画面
    path: '/v3/inspectionSettlementComplete',
    name: 'InspectionSettlementCompleteV3',
    component: InspectionSettlementCompleteV3
  },
  {
    // カーケアTOP画面
    path: '/v3/carcaretop',
    name: 'CarCareTopV3',
    component: CarCareTopV3
  },
  {
    // 車検TOP画面
    path: '/v3/inspectiontop',
    name: 'InspectionTopV3',
    component: InspectionTopV3
  },
  {
    // 希望日選択画面
    path: '/v3/preferreddate',
    name: 'PreferredDateV3',
    component: PreferredDateV3
  },
  {
    // GMO表示用画面
    path: '/v3/payment',
    name: 'PaymentV3',
    component: PaymentV3
  },
  {
    path: '/v3/inspectionThanks',
    name: 'InspectionThanksV3',
    component: InspectionThanksV3
  },
  {
    // 車検詳細画面
    path: '/v3/inspectiondetail',
    name: 'InspectionDetailV3',
    component: InspectionDetailV3
  },
  {
    // リースTOP画面
    path: '/v3/leasetop',
    name: 'LeaseTopV3',
    component: LeaseTopV3
  },
  {
    // カードスペック選択画面
    path: '/v3/cardspecSelect',
    name: 'CardSpecSelectV3',
    component: CardSpecSelectV3
  },
  {
    // カードスペック画面(オーパス)
    path: '/v3/cardspecOpus',
    name: 'CardSpecOpusV3',
    component: CardSpecOpusV3
  },
  {
    // カードスペック画面(ハウス)
    path: '/v3/cardspecHouse',
    name: 'CardSpecHouseV3',
    component: CardSpecHouseV3
  },
  {
    // 車検証情報登録画面
    path: '/v3/optionCarQR',
    name: 'OptionCarQRV3',
    component: OptionCarQRV3
  },
  {
    // リダイレクト用車検情報入力画面
    path: '/v3/redirectcar',
    name: 'RedirectCarV3',
    component: RedirectCarV3
  },
  {
    // リダイレクト用希望日選択画面
    path: '/v3/redirectpreferreddate',
    name: 'RedirectPreferredDateV3',
    component: RedirectPreferredDateV3
  },
  {
    // アカウント削除 削除内容確認画面
    path: '/v3/accountDelete/confirm',
    name: 'AccountDeleteConfirmV3',
    component: AccountDeleteConfirmV3
  },
  {
    // アカウント削除 削除完了画面
    path: '/v3/accountDelete/complete',
    name: 'AccountDeleteCompleteV3',
    component: AccountDeleteCompleteV3
  },
  {
    // メンテナンスパックTop画面
    path: '/v3/MaintenancePack/top',
    name: 'MaintenancePackTopV3',
    component: MaintenancePackTopV3
  },
  {
    // メンテナンスパック車検証情報確認画面
    path: '/v3/MaintenancePack/CarInspectionConfirm',
    name: 'CarInspectionConfirmV3',
    component: CarInspectionConfirmV3
  },
  {
    // メンテナンスパック申込画面
    path: '/v3/MaintenancePack/apply',
    name: 'MaintenancePackApplyV3',
    component: MaintenancePackApplyV3
  },
  {
    // メンテナンスパック利用規約画面
    path: '/v3/MaintenancePack/termsOfService',
    name: 'MaintenancePackTermsOfServiceV3',
    component: MaintenancePackTermsOfServiceV3
  },
  {
    // メンテナンスパック仮申し込み完了画面
    path: '/v3/MaintenancePack/applyComplete',
    name: 'MaintenancePackApplyCompleteV3',
    component: MaintenancePackApplyCompleteV3
  },
  {
    // アプリTOPリダイレクト画面
    path: '/v3/moveAppTop',
    name: 'AppTopV3',
    component: AppTopV3
  },
  {
    // カーメンテナンス画面
    path: '/v3/maintenanceReservation',
    name: 'MaintenanceReservationV3',
    component: MaintenanceReservationV3
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
